export const ROLES = {
  GUEST: 'guest',
  ADMIN: 'administrator',
  STAFF: 'staff',
};

export const normalizeRoles = (role: string | string[] | null | undefined): string[] => {
  const roles = Array.isArray(role) ? role : [role];
  return roles
    .filter((value): value is string => !!value)
    .map(value => value.toLowerCase());
};

export const hasAnyRole = (
  role: string | string[] | null | undefined,
  allowedRoles: string[],
): boolean => {
  const normalizedRoles = normalizeRoles(role);
  return normalizedRoles.some(value => allowedRoles.includes(value));
};
